module.exports = __webpack_public_path__ + "7e4b29ba/img/comment-question-icon.7dd26e04.svg";